<template>
  <div style="margin-top: 10px">
    <div class="row">
      <div class="col-md-12">
        <label>Usuario</label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-sm-8 col-xs-6">
        <base-input v-model="model.usuarioSPK" @blur="change"></base-input>
      </div>
    </div>
    <div class="row" style="text-align:right">
      <div class="col-md-6">
        <label>{{username}}</label>
      </div>

      <div class="col-md-6">
        <base-button
          type="warning"
          size="lg"
          @click="validateUser"
          style="margin: auto; margin-top: 10px"
        >
          <i class="fa fa-check fa-fw"></i>Validar
        </base-button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <money-with-indicator v-model="model.Importe" v-on:blur="change" v-on:validatedOK="onSaldoOK"/>
      </div>
    </div>
  </div>
</template>


<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import MoneyWithIndicator from '@/components/Custom/MoneyWithIndicator';

export default {
  components: {
    "money-with-indicator": MoneyWithIndicator
  },
  props: {
    model: {
      Aux1: "",
      Aux2: "",
      Aux3: "",
      Aux4: "",
      Importe: "",
      Validate: false,
      Errors: []
    }
  },
  data() {
    return { username: "", validated: false };
  },
  methods: {
    change(element) {
      this.validate();
      this.$emit("input", this.model);
    },
    validateUser() {
      let context = this;
      axiosHelpers.axiosGet(
        "Recarga/ValidateArticle",
        {
          ArticleID: 115,
          Aux: context.model.usuarioSPK
        },
        this,
        function(data) {
          context.validated = false;

          if (data.ResponseVM.Result == 0) {
            var msgSplit = data.ResponseVM.Message.split("-");
            context.model.Aux4 = msgSplit[0].trim();
            context.username = msgSplit[1].trim();
            context.validated = true;
          } else {
            context.username = "No se encontro el usuario";
          }
          context.validate();
          context.$emit("input", context.model);
        }
      );
    },
    validate() {
      let context = this;
      context.model.Errors = [];

      if (context.model.Aux4.length == 0 || !context.validated) {
        context.model.Validate = false;
        context.model.Errors.push("Debe ingresar y validar el usuario");
      } else if (context.model.Importe <= 0) {
        context.model.Validate = false;
        context.model.Errors.push("El importe no puede ser menor que 0");
      } else {
        context.model.Validate = true;
      }
    },
    onSaldoOK(val) {
      this.$emit("saldoOK", val);
    }
  },
  beforeMount: function() {
    let context = this;
    context.username = "";
    context.validated = false;
  }
};
</script>